import { Link } from "react-router-dom";
import { Star, Trash2 } from "lucide-react";
import { useWatchlist } from "../lib/watchlist";
import { SectionHead } from "../components/common";
import { shortAddr } from "../lib/format";
import usePageMeta from "../lib/usePageMeta";

const groupsMeta = {
  token: { title: "Tokens", link: (i) => `/token/${i.id}` },
  wallet: { title: "Wallets", link: (i) => `/wallet/${i.id}` },
};

export default function Watchlist() {
  usePageMeta("Watchlist", "Your saved Robinhood Chain tokens and wallets.");
  const { items, toggle } = useWatchlist();

  if (!items.length) {
    return (
      <div className="space-y-4">
        <SectionHead title="Watchlist" />
        <div className="t-card p-10 text-center" data-testid="watchlist-empty">
          <Star size={28} className="mx-auto text-[#3F3F46] mb-3" />
          <p className="text-[#9CA3AF] text-sm">Your watchlist is empty.</p>
          <p className="text-[#6B7280] text-xs mt-1">Star tokens or wallets to track them here. Stored locally in your browser — no login needed.</p>
          <Link to="/tokens" className="inline-block mt-4 px-4 py-2 bg-[#059669] hover:bg-[#047857] text-white text-[13px] rounded-sm transition-colors" data-testid="watchlist-browse-tokens">Browse Tokens</Link>
        </div>
      </div>
    );
  }

  return (
    <div className="space-y-5">
      <SectionHead title="Watchlist" />
      {Object.entries(groupsMeta).map(([type, meta]) => {
        const group = items.filter((i) => i.type === type);
        if (!group.length) return null;
        return (
          <div key={type}>
            <h3 className="text-xs uppercase tracking-wider text-[#6B7280] mb-2">{meta.title}</h3>
            <div className="t-card" data-testid={`watchlist-group-${type}`}>
              {group.map((i) => (
                <div key={i.id} className="flex items-center px-3 py-2.5 border-b border-[#1a1a1a] last:border-0 hover:bg-[#1A1A1A] transition-colors">
                  <Link to={meta.link(i)} className="flex-1 flex items-center gap-3" data-testid={`watchlist-item-${i.id}`}>
                    <span className="text-[13px] font-medium">{i.label}</span>
                    <span className="num text-xs text-[#6B7280]">{i.sub?.startsWith?.("0x") ? shortAddr(i.sub) : i.sub}</span>
                  </Link>
                  <span className="text-[10px] text-[#6B7280] mr-3">{new Date(i.added_at).toLocaleDateString()}</span>
                  <button data-testid={`watchlist-remove-${i.id}`} onClick={() => toggle(i)} className="text-[#6B7280] hover:text-[#EF4444] transition-colors"><Trash2 size={14} /></button>
                </div>
              ))}
            </div>
          </div>
        );
      })}
    </div>
  );
}
